﻿// @ts-nocheck
// monthly report rendering

function populateMonthSelect() {
  const monthlySummary = getMonthlySummary();
  const months = Object.keys(monthlySummary).sort().reverse();
  const select = document.getElementById("reportMonthSelect");
  
  if (select) {
    select.innerHTML = '<option value="">– Select month –</option>';
    months.forEach((month) => {
      const option = document.createElement("option");
      option.value = month;
      const [year, m] = month.split("-");
      const monthName = new Date(year, parseInt(m) - 1).toLocaleString("default", { month: "long", year: "numeric" });
      option.textContent = monthName;
      select.appendChild(option);
    });
  }
}

function renderMonthlyReport(month) {
  const weeklyBreakdown = getWeeklyBreakdown(month);
  const projectBreakdown = getProjectBreakdown(month);
  const dailyBreakdown = getDailyBreakdown(month);
  const content = document.getElementById("monthlyReportContent");
  
  if (!content) return;
  
  // Check if there's any data for this month
  if (Object.keys(weeklyBreakdown).length === 0) {
    content.innerHTML = '<div style="text-align: center; color: var(--text-secondary); padding: 2rem;">No sessions recorded for this month</div>';
    return;
  }
  
  // Calculate totals
  let totalHours = 0;
  let totalEarned = 0;
  let sessionCount = 0;
  Object.values(weeklyBreakdown).forEach((week) => {
    totalHours += week.hours;
    totalEarned += week.earned;
    sessionCount += week.sessions || 0;
  });

  const [year, monthNum] = month.split("-");
  const monthName = new Date(year, parseInt(monthNum) - 1).toLocaleString("default", { month: "long", year: "numeric" });

  let html = `
    <div style="margin-bottom: 1.5rem;">
      <h3>${monthName} Summary</h3>
      <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 1rem; margin-bottom: 1.5rem;">
        <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 0.5rem; border-left: 4px solid var(--primary);">
          <div style="font-size: 0.875rem; color: var(--text-secondary); margin-bottom: 0.5rem;">Total Hours</div>
          <div style="font-size: 1.75rem; font-weight: 600; color: var(--primary);">${totalHours.toFixed(1)}h</div>
        </div>
        <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 0.5rem; border-left: 4px solid var(--success);">
          <div style="font-size: 0.875rem; color: var(--text-secondary); margin-bottom: 0.5rem;">Total Earned</div>
          <div style="font-size: 1.75rem; font-weight: 600; color: var(--success);">$${totalEarned.toFixed(2)}</div>
        </div>
        <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 0.5rem; border-left: 4px solid var(--accent);">
          <div style="font-size: 0.875rem; color: var(--text-secondary); margin-bottom: 0.5rem;">Sessions</div>
          <div style="font-size: 1.75rem; font-weight: 600; color: var(--accent);">${sessionCount}</div>
        </div>
        <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 0.5rem; border-left: 4px solid #f59e0b;">
          <div style="font-size: 0.875rem; color: var(--text-secondary); margin-bottom: 0.5rem;">Avg/Day</div>
          <div style="font-size: 1.75rem; font-weight: 600; color: #f59e0b;">${(totalHours / Object.keys(dailyBreakdown).length).toFixed(1)}h</div>
        </div>
      </div>
    </div>
  `;

  // Weekly breakdown
  html += `
    <div style="margin-bottom: 1.5rem;">
      <h3>Weekly Breakdown</h3>
      <div class="table-wrapper">
        <table style="width: 100%; border-collapse: collapse;">
          <thead>
            <tr style="background: var(--bg-secondary); border-bottom: 2px solid var(--border);">
              <th style="padding: 0.75rem; text-align: left; font-weight: 600;">Week</th>
              <th style="padding: 0.75rem; text-align: center; font-weight: 600;">Days</th>
              <th style="padding: 0.75rem; text-align: right; font-weight: 600;">Sessions</th>
              <th style="padding: 0.75rem; text-align: right; font-weight: 600;">Hours</th>
              <th style="padding: 0.75rem; text-align: right; font-weight: 600;">Earned</th>
              <th style="padding: 0.75rem; text-align: right; font-weight: 600;">Avg/Day</th>
            </tr>
          </thead>
          <tbody>
  `;
  
  Object.entries(weeklyBreakdown).forEach(([week, data]) => {
    const avgPerDay = (data.hours / data.days.size).toFixed(1);
    html += `
      <tr style="border-bottom: 1px solid var(--border);">
        <td style="padding: 0.75rem;">${week}</td>
        <td style="padding: 0.75rem; text-align: center;">${data.days.size}</td>
        <td style="padding: 0.75rem; text-align: right;">${data.sessions || 0}</td>
        <td style="padding: 0.75rem; text-align: right;">${data.hours.toFixed(1)}h</td>
        <td style="padding: 0.75rem; text-align: right;">$${data.earned.toFixed(2)}</td>
        <td style="padding: 0.75rem; text-align: right;">${avgPerDay}h</td>
      </tr>
    `;
  });
  
  html += `
          </tbody>
        </table>
      </div>
    </div>
  `;

  // Daily breakdown
  html += `
    <div style="margin-bottom: 1.5rem;">
      <h3>Daily Breakdown</h3>
      <div class="table-wrapper">
        <table style="width: 100%; border-collapse: collapse;">
          <thead>
            <tr style="background: var(--bg-secondary); border-bottom: 2px solid var(--border);">
              <th style="padding: 0.75rem; text-align: left; font-weight: 600;">Date</th>
              <th style="padding: 0.75rem; text-align: center; font-weight: 600;">Sessions</th>
              <th style="padding: 0.75rem; text-align: right; font-weight: 600;">Hours</th>
              <th style="padding: 0.75rem; text-align: right; font-weight: 600;">Earned</th>
            </tr>
          </thead>
          <tbody>
  `;
  
  Object.entries(dailyBreakdown)
    .sort((a, b) => new Date(b[0]) - new Date(a[0]))
    .forEach(([date, data]) => {
      html += `
        <tr style="border-bottom: 1px solid var(--border);">
          <td style="padding: 0.75rem;">${new Date(date).toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" })}</td>
          <td style="padding: 0.75rem; text-align: center;">${data.sessions}</td>
          <td style="padding: 0.75rem; text-align: right;">${data.hours.toFixed(1)}h</td>
          <td style="padding: 0.75rem; text-align: right;">$${data.earned.toFixed(2)}</td>
        </tr>
      `;
    });
  
  html += `
          </tbody>
        </table>
      </div>
    </div>
  `;

  // Project breakdown with percentages and rate info
  html += `
    <div style="margin-bottom: 1.5rem;">
      <h3>By Project/Client</h3>
      <div class="table-wrapper">
        <table style="width: 100%; border-collapse: collapse;">
          <thead>
            <tr style="background: var(--bg-secondary); border-bottom: 2px solid var(--border);">
              <th style="padding: 0.75rem; text-align: left; font-weight: 600;">Project</th>
              <th style="padding: 0.75rem; text-align: center; font-weight: 600;">Sessions</th>
              <th style="padding: 0.75rem; text-align: right; font-weight: 600;">Hours</th>
              <th style="padding: 0.75rem; text-align: right; font-weight: 600;">Rate</th>
              <th style="padding: 0.75rem; text-align: right; font-weight: 600;">Earned</th>
              <th style="padding: 0.75rem; text-align: right; font-weight: 600;">% Total</th>
            </tr>
          </thead>
          <tbody>
  `;
  
  Object.entries(projectBreakdown)
    .sort((a, b) => b[1].earned - a[1].earned)
    .forEach(([project, data]) => {
      const percentage = ((data.earned / totalEarned) * 100).toFixed(1);
      const rate = data.rate || 180;
      html += `
        <tr style="border-bottom: 1px solid var(--border);">
          <td style="padding: 0.75rem;"><strong>${project}</strong></td>
          <td style="padding: 0.75rem; text-align: center;">${data.sessions || 0}</td>
          <td style="padding: 0.75rem; text-align: right;">${data.hours.toFixed(1)}h</td>
          <td style="padding: 0.75rem; text-align: right;">$${rate}/hr</td>
          <td style="padding: 0.75rem; text-align: right;">$${data.earned.toFixed(2)}</td>
          <td style="padding: 0.75rem; text-align: right; font-weight: 600;">${percentage}%</td>
        </tr>
      `;
    });
  
  html += `
          </tbody>
        </table>
      </div>
    </div>
  `;

  // Average metrics
  const avgHourlyRate = (totalEarned / totalHours).toFixed(2);
  const workingDays = Object.keys(dailyBreakdown).length;
  html += `
    <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1rem; margin-bottom: 1.5rem;">
      <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 0.5rem;">
        <div style="font-size: 0.875rem; color: var(--text-secondary); margin-bottom: 0.5rem;">Avg Hourly Rate</div>
        <div style="font-size: 1.5rem; font-weight: 600;">$${avgHourlyRate}/hr</div>
      </div>
      <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 0.5rem;">
        <div style="font-size: 0.875rem; color: var(--text-secondary); margin-bottom: 0.5rem;">Working Days</div>
        <div style="font-size: 1.5rem; font-weight: 600;">${workingDays} days</div>
      </div>
      <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 0.5rem;">
        <div style="font-size: 0.875rem; color: var(--text-secondary); margin-bottom: 0.5rem;">Sessions/Day Avg</div>
        <div style="font-size: 1.5rem; font-weight: 600;">${(sessionCount / workingDays).toFixed(1)}</div>
      </div>
    </div>
  `;

  html += `
    <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 0.5rem; border-left: 4px solid var(--accent);">
      <h3 style="margin-top: 0;">Invoice Summary for ${monthName}</h3>
      <p style="margin-bottom: 1rem; color: var(--text-secondary);">Use this to create invoices for each client:</p>
      <div style="background: var(--bg-primary); padding: 1rem; border-radius: 0.375rem; font-family: monospace; font-size: 0.875rem; overflow-x: auto;">
  `;
  
  Object.entries(projectBreakdown)
    .sort((a, b) => b[1].earned - a[1].earned)
    .forEach(([project, data]) => {
      const rate = data.rate || 180;
      html += `${project}: ${data.hours.toFixed(2)} hours @ $${rate}/hr = $${data.earned.toFixed(2)}<br>`;
    });
  
  html += `
      </div>
    </div>
  `;

  content.innerHTML = html;
}
